import axios from '@/libs/api.request'

const Api = {
  AppNodes: '/app/member/nodes',
  AppNode: '/app/member/node'
}

export const getAppNodes = (data) => {
  return axios.request({
    url: Api.AppNodes,
    data: data,
    method: 'post'
  })
}

export const updateAppNode = (data) => {
  return axios.request({
    url: Api.AppNode,
    data: data,
    method: 'put'
  })
}



// WEBPACK FOOTER //
// ./src/api/inapp.js